import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../src/texts/tooltips';
import { APP_TEXTS } from '@texts';

const Index = props => (
  <React.Fragment>
    {props.isImporting ? (
      <div className="d-inline">
        <button className="w-auto m-2" /*role="button"*/ onClick={props.onConfirmImport}>
          <span>{APP_TEXTS.LABEL_CONFIRM.Content}</span>
        </button>
        <button className="w-auto m-2" /*role="button"*/ onClick={props.onCancelImport}>
          <span>{APP_TEXTS.BUTTONS_CANCEL.Content}</span>
        </button>
      </div>
    ) : (
      <div className="d-inline mt-2">
        <Tooltip content={APP_TOOLTIPS.TOOLTIP_BUTTON_ADD_LOAD_COMBINATION.Content}>
          <button className="btn controls__button" /*role="button"*/ onClick={props.onAdd}>
            <span className="icon_add" />
          </button>
        </Tooltip>
        <Tooltip content={APP_TOOLTIPS.TOOLTIP_BUTTON_REMOVE_LOAD_COMBINATION.Content}>
          <button disabled={!props.canRemove} className="btn controls__button" /*role="button"*/ onClick={props.onRemove}>
            <span className="icon_remove" />
          </button>
        </Tooltip>
        <Tooltip placement="right" content={
          APP_TOOLTIPS.TOOLTIP_BUTTON_IMPORT_COMBINATIONS.Content + "</br>" + APP_TOOLTIPS.TOOLTIP_IMPORT_LOADS_HEADER_NOT_REQUIRED.Content
        }>
          <button className="btn controls__button" /*role="button"*/ onClick={props.onStartImport}>
            <span className="icon_import_loads" />
          </button>
        </Tooltip>
      </div>
    )}
  </React.Fragment>
);

Index.propTypes = {
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  canRemove: PropTypes.bool,
  isImporting: PropTypes.bool.isRequired,
  onStartImport: PropTypes.func.isRequired,
  onConfirmImport: PropTypes.func.isRequired,
  onCancelImport: PropTypes.func.isRequired
};

export default Index;



// WEBPACK FOOTER //
// ./src/components/Controls/index.js